import React from "react";
import Background from "../components/Background";
import LoginQRCode from "../components/LoginViewComponents/LoginQRCode";
import LoginPIN from "../components/LoginViewComponents/LoginPIN";
import HorizontalLine from "../components/HorizontalLine";
import "../styles/UserSettings.css";
import { connect } from "react-redux";
import { dLockPairUserInLibrarian, getdLockLibrarianPairStatus } from "../api/loginUserInLibrarian";
import { enqueueSnackbar } from "notistack";
import { generatePassword } from "../utils/generators";
import setNewUserPassword from "../api/setNewUserPassword";
import Button from "../components/Button";

class UserSettings extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: "pair",
            currentPassword: "",
            newPassword: "",
            confirmPassword: "",
            passwordError: "",
            isPasswordValid: false,
            showPassword: false,
            countPaired: 0,
            lastAddress: "",
        };

        this.qrCodePollingRef = React.createRef();
        this.pinPollingRef = React.createRef();
        this.loginPinRef = React.createRef();
    }

    handleClose = () => {
        window.history.back();
    }


    handleCurrentPasswordChange = (e) => {
        this.setState({ currentPassword: e.target.value });
    }

    handleNewPasswordChange = (e) => {
        this.setState({ newPassword: e.target.value }, this.validateNewPasswords);
    }

    handleConfirmPasswordChange = (e) => {
        this.setState({ confirmPassword: e.target.value }, this.validateNewPasswords);
    }

    togglePasswordVisibility = () => {
        this.setState(prevState => ({
            showPassword: !prevState.showPassword
        }));
    }

    componentDidMount() {
        this.checkPairStatus();
    } checkPairStatus = async () => {
        try {
            if (this.props.user && this.props.user.session) {
                const result = await getdLockLibrarianPairStatus(this.props.user.username);

                if (result && !result.errors) {
                    // Set last address with truncation (first 4 + ... + last 4)
                    const address = result.lastAddress || "";
                    const truncatedAddress = address.length > 8
                        ? `${address.substring(0, 4)}...${address.substring(address.length - 4)}`
                        : address;

                    this.setState({
                        isPaired: result.paired || false,
                        pairStatusChecked: true,
                        lastAddress: truncatedAddress
                    });
                    this.setState({
                        countPaired: result.count
                    })
                }
            }
        } catch (error) {
            console.error("Error checking pair status:", error);
        }
    }

    handleTabChange = (tab) => {
        this.setState({ activeTab: tab });
    };

    stopAllPolling = () => {
        // Check if the components have provided their clearPolling functions
        if (this.qrCodePollingRef.current) {
            this.qrCodePollingRef.current();
        }

        if (this.pinPollingRef.current) {
            this.pinPollingRef.current();
        }
    };

    validateNewPasswords = () => {
        const { newPassword, confirmPassword } = this.state;

        if (newPassword && confirmPassword) {
            if (newPassword !== confirmPassword) {
                this.setState({
                    passwordError: "Hasła nie są identyczne",
                    isPasswordValid: false
                });
            } else if (newPassword.length < 6) {
                this.setState({
                    passwordError: "Hasło musi mieć co najmniej 6 znaków",
                    isPasswordValid: false
                });
            } else {
                this.setState({
                    passwordError: "",
                    isPasswordValid: true
                });
            }
        } else {
            this.setState({
                passwordError: "",
                isPasswordValid: false
            });
        }
    }

    handleSavePassword = async () => {
        const { currentPassword, newPassword, isPasswordValid } = this.state;
        if (!isPasswordValid) {
            return;
        }

        try {
            await setNewUserPassword(this.props.user, currentPassword, newPassword);
            enqueueSnackbar("Hasło zostało zmienione", { variant: "success" });
            this.setState({
                currentPassword: "",
                newPassword: "",
                confirmPassword: ""
            });
        } catch (error) {
            enqueueSnackbar(
                error.message || "Wystąpił błąd podczas zmiany hasła",
                { variant: "error" }
            );
        }
    }

    handlePairStatusChange = async (data) => {
        console.log("Pairing status changed:", data);
        if (data.status === "APPROVED") {
            try {
                // Set pairing flag to prevent duplicate processing
                this.setState({ isPairing: true });

                this.stopAllPolling();
                data.username = this.props.user.username;
                let res = await dLockPairUserInLibrarian(data)
                if (res.user === null) {
                    throw new Error("not_found");
                }


                let ua = data.userDHCAddress
                let truncAddr = `${ua.substring(0, 4)}...${ua.substring(ua.length - 4)}`
                enqueueSnackbar(`Sparowano poprawnie z ${truncAddr}`, { variant: "success" });
                // reload the page to reflect changes
                this.setState({ isPaired: true, countPaired: this.state.countPaired + 1, lastAddress: truncAddr });

            } catch (error) {
                // Display error in LoginPIN component
                if (this.loginPinRef.current) {
                    this.loginPinRef.current.setError(error.message || "Błąd parowania");
                    this.loginPinRef.current.resetPinState();
                }
                enqueueSnackbar("Błąd parowania", { variant: "error" });
            }
        } else if (data.status === "REJECTED") {
            if (this.loginPinRef.current) {
                this.loginPinRef.current.setError("Odrzucone");
                this.loginPinRef.current.resetPinState();
            }
            enqueueSnackbar("Użytkownik odrzucił parowanie", { variant: "error" });
        }    // Reset authenticating state to allow retry

        this.setState({ isPairing: false });
    };

    passGenerator = () => {
        let newPass = generatePassword();
        this.setState({ newPassword: newPass, confirmPassword: newPass }, this.validateNewPasswords);
    }

    render() {
        const { activeTab } = this.state;
        const user = this.props.user;
        const withHowMany = (this.state.countPaired === 1) ? "z jednym użytkownikiem" : `z ${this.state.countPaired} użytkownikami`;

        return (
            <>
                <div className="main-settings-container">

                    <Background height="45vh" />

                    <div className="settings-content">
                        <button
                            onClick={this.handleClose}
                            style={{
                                position: 'absolute',
                                top: '10px',
                                right: '10px',
                                background: 'none',
                                border: 'none',
                                fontSize: '24px',
                                fontWeight: 'bold',
                                cursor: 'pointer',
                                zIndex: 10,
                                width: '40px',
                                height: '40px',
                                borderRadius: '50%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: '#333',
                                transition: 'background-color 0.2s ease'
                            }}
                            onMouseOver={(e) => { e.currentTarget.style.backgroundColor = '#eee' }}
                            onMouseOut={(e) => { e.currentTarget.style.backgroundColor = 'transparent' }}
                        >
                            ×
                        </button>
                        <h2 className="settings-title">Ustawienia użytkownika</h2>

                        <div className="settings-tabs">
                            <button
                                className={`tab-button ${activeTab === "details" ? "active" : ""}`}
                                onClick={() => this.handleTabChange("details")}
                            >
                                Hasło
                            </button>
                            <button
                                className={`tab-button ${activeTab === "pair" ? "active" : ""}`}
                                onClick={() => this.handleTabChange("pair")}
                            >
                                dLock - Parowanie
                            </button>
                        </div>

                        <div className="tab-content">
                            {activeTab === "details" && (
                                <div className="details-tab">
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                        <label><b><h5>Zmiana hasła użytkownika <b>{user.username}</b></h5></b></label>
                                    </div>

                                    <div className="form-group">

                                        <label>Obecne hasło:</label>
                                        <input
                                            type="password"
                                            value={this.state.currentPassword}
                                            onChange={this.handleCurrentPasswordChange}
                                            className="settings-input"
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label>Nowe hasło:</label>
                                        <div style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            width: '100%'
                                        }}>
                                            <input
                                                type={this.state.showPassword ? "text" : "password"}
                                                value={this.state.newPassword}
                                                onChange={this.handleNewPasswordChange}
                                                className={`settings-input ${this.state.passwordError ? "settings-input-error" : ""}`}
                                                style={{ flex: 1 }}
                                            />
                                            <button
                                                type="button"
                                                onClick={this.togglePasswordVisibility}
                                                style={{
                                                    background: 'none',
                                                    border: 'none',
                                                    cursor: 'pointer',
                                                    marginLeft: '5px',
                                                    padding: '0 10px'
                                                }}
                                            >
                                                <i className={`fas ${this.state.showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                                            </button>
                                            <Button
                                                text="Generuj"
                                                onClick={() => this.passGenerator()}
                                                styleOptions={{ marginLeft: '5px' }}
                                            />
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label>Powtórz hasło:</label>
                                        <input
                                            type="password"
                                            value={this.state.confirmPassword}
                                            onChange={this.handleConfirmPasswordChange}
                                            className={`settings-input ${this.state.passwordError ? "settings-input-error" : ""}`}
                                        />
                                        {this.state.passwordError && (
                                            <div className="password-error">{this.state.passwordError}</div>
                                        )}
                                    </div>

                                    <button
                                        className="save-button"
                                        onClick={this.handleSavePassword}
                                        disabled={!this.state.isPasswordValid || !this.state.currentPassword}
                                    >
                                        Zapisz zmiany
                                    </button>
                                </div>
                            )}
                            {activeTab === "pair" && (
                                <div className="pair-tab">
                                    <p> Sparuj to konto z aplikacją mobilną audiobook na Twoim urządzeniu.
                                        Sparowanie umożliwi Ci szybkie zalogowanie się telefonem (kodem QR lub PIN-em).
                                    </p>
                                    {this.state.isPaired && (
                                        <div style={{
                                            backgroundColor: "#e8f5e9",
                                            padding: "10px",
                                            borderRadius: "4px",
                                            marginBottom: "15px",
                                            color: "#2e7d32",
                                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
                                        }}>
                                            <div style={{ textAlign: 'center' }}>
                                                Konto <strong>{user.username}</strong> jest już sparowane <strong>{withHowMany}</strong> aplikacji audiobook.<br />
                                                Ostatnio sparowany adres to <strong>{this.state.lastAddress}</strong>.<br />
                                                Zeskanuj kod lub wpisz PIN, aby sparować konto z Twoją aplikacją.
                                            </div>
                                        </div>
                                    )}
                                    <div>
                                        <div><LoginQRCode
                                            onAuthStatusChange={this.handlePairStatusChange}
                                            intent='PAIR'
                                            clearPollingRef={fn => this.qrCodePollingRef.current = fn}
                                        /></div>
                                        <HorizontalLine />
                                        <div><LoginPIN
                                            ref={this.loginPinRef}
                                            onAuthStatusChange={this.handlePairStatusChange}
                                            intent='PAIR'
                                            clearPollingRef={fn => this.qrCodePollingRef.current = fn}
                                        /></div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </>

        );
    }
}

// Connect to Redux

const mapStateToProps = (state) => ({
    user: state.authentication.user
});

export default connect(mapStateToProps)(UserSettings);